<nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
  <div class="container" [dir]="languageService.getDir()">
    <button class="navbar-toggler navbar-toggler-right" type= "button" *ngIf="isLoggedIn"
            data-toggle="collapse" data-target="#navbarResponsive">
      <i class="fas fa-bars"></i>
    </button>
    <div class="navbar-column navbar-column-menu">
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav" [class.text-right]="languageService.isCurrent('Hebrew')">
          <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show" *ngIf="isLoggedIn && isSuperAdmin">
            <a [routerLink]="['/book/3']" routerLinkActive="active" class="nav-link"
               [dir]="languageService.getDir()">
              {{'MENU.BOOK_NOW' | translate}}
            </a>
          </li>
          <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show" *ngIf="isBarista">
            <a [routerLink]="['/coffee/make']" routerLinkActive="active" class="nav-link"
               [dir]="languageService.getDir()">
              {{'MENU.MAKE_A_COFFEE' | translate}}
            </a>
          </li>
          <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
            <a href class="nav-link" (click)="logout()" *ngIf="isLoggedIn"
               [dir]="languageService.getDir()">
              {{'MENU.LOGOUT' | translate}}
            </a>
          </li>
          <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
            <a [routerLink]="['user']" routerLinkActive="active" class="nav-link" *ngIf="isLoggedIn && isSuperAdmin"
               [dir]="languageService.getDir()">
              {{'MENU.ACCOUNT' | translate}}
            </a>
          </li>
          <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
            <a [routerLink]="['office-admin']" routerLinkActive="active" class="nav-link" *ngIf="isLoggedIn && isSuperAdmin"
               [dir]="languageService.getDir()">
              {{'MENU.SUPER_ADMIN' | translate}}
            </a>
          </li>
          <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
            <a [routerLink]="['admin']" routerLinkActive="active" class="nav-link" *ngIf="isLoggedIn && (isAdmin || isSuperAdmin)"
               [dir]="languageService.getDir()">
              {{'MENU.ADMIN' | translate}}
            </a>
          </li>
          <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
            <a class="nav-link" href="https://tabitisrael.co.il/tabit-order?site=65954054435dcf64dc510fbf&step=enter" target="_blank"
               *ngIf="isLoggedIn && isSuperAdmin" [dir]="languageService.getDir()">
              {{'MENU.MEALS' | translate}}
            </a>
          </li>
        </ul>
      </div>
      <a class="switch-lang-button" [dir]="languageService.getDir()" (click)="switchLanguage()">
        {{languageService.getLangNameToSwitch(true)}}
      </a>
    </div>
<!--    <div class="logo-spring" *ngIf="!isLoggedIn"></div>-->
    <div class="navbar-column navbar-column-login" *ngIf="!isLoggedIn" style="justify-content: center">
      <a class="negative-button login-button" *ngIf="!isLoggedIn" [routerLink]="['home/login']">
      <span class="login-button-text">{{'MENU.LOGIN_SIGNUP' | translate}}</span>
    </a>
    </div>
    <div class="navbar-column navbar-column-brand">
      <a class="navbar-brand" href="https://alef-center.com">
        <svg width="117" height="80" viewBox="0 0 117 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_270_364)">
            <g style="mix-blend-mode: multiply">
            <path d="M42.6957 43.6088H8.06555V78.2585H42.6957V43.6088Z" fill="#FFCF56"/>
          </g>
            <g style="mix-blend-mode: multiply">
          <path d="M108.53 1.73914H73.9001V36.3889H108.53V1.73914Z" fill="#FFCF56"/>
          </g>
            <g style="mix-blend-mode: multiply">
          <path d="M15.2454 -0.00115878L0 32.7113L101.351 79.9986L116.596 47.2862L15.2454 -0.00115878Z"
                fill="#1916E8"/>
          </g>
          </g>
          <defs>
            <clipPath id="clip0_270_364">
              <rect width="116.596" height="80" fill="white"/>
            </clipPath>
          </defs>
        </svg>
<!--      <img class="logo-img" alt="Logo" src="assets/img/logo-cream.png"/>-->
    </a>
    </div>
  </div>
</nav>
